import {
  HighwayArea,
  ManualArea,
  Obstacle,
  RackingArea,
  SingularStationArea,
  StationaryArea,
} from '@thive/fddm-types';

import { Area } from '../types';
import { assertNever } from '@/helpers/utils';

// @description only discriminator for now is that a manual area does not have any loadHandlingPoiSpecs...
export const isManualArea = (value: Area): value is ManualArea => value.areaType === 'MANUAL';

export const isExtractionStationaryArea = (value: Area): value is StationaryArea =>
  value.areaType === 'STATIONARY' && value.stationaryType === 'EXTRACTION';

export const isInsertionStationaryArea = (value: Area): value is StationaryArea =>
  value.areaType === 'STATIONARY' && value.stationaryType === 'INSERTION';

export const isHighwayArea = (value: Area): value is HighwayArea => value.areaType === 'HIGHWAY';

export const isOneWayHighway = (value: Area): value is HighwayArea =>
  isHighwayArea(value) && value.highwayPoiSpecs.every((poiSpec) => poiSpec.roadType === 'ONE_WAY');

export const isRackingArea = (value: Area): value is RackingArea => value.areaType === 'RACKING';

export const isShuttleRackingArea = (value: Area): value is RackingArea =>
  isRackingArea(value) && value.rackType === 'SHUTTLE';

export const isShuttleStorageRackingArea = (value: Area): value is RackingArea =>
  isShuttleRackingArea(value) && value.rackingLoadHandlingType === 'STORAGE';

export const isSingularStationArea = (value: Area): value is SingularStationArea =>
  value.areaType === 'SINGULAR';

export const areOnlySingularStationAreas = (
  areas: Area[],
): areas is Extract<Area, { areaType: 'SINGULAR' }>[] => areas.every(isSingularStationArea);

export const isStationaryArea = (value: Area): value is StationaryArea =>
  value.areaType === 'STATIONARY';

export const isWallObstacle = (obstacle: Obstacle): boolean => obstacle.appearance === 'WALL';

export const isRegularObstacle = (obstacle: Obstacle): boolean => obstacle.appearance !== 'WALL';

export const areaSupportsCutOutIds = (area: Area): area is Exclude<Area, ManualArea> => {
  switch (area.areaType) {
    case 'STATIONARY':
    case 'SINGULAR':
    case 'HIGHWAY':
    case 'RACKING':
      return true;
    case 'MANUAL':
      // NOTE: this area does not have cutOutIds
      return false;
    default:
      assertNever(area);
  }
};
